<div class="container">
    <div class="row">
        <div class="col p-0">
            <app-reports-filter [selectedReport]="reportModel" [generateDisabled]="generateDisabled"
                [showClassFilter]="false"  (doFilter)="showReport($event)" (filtersSelected)="filerInstructors($event)"
                (generateReport)="generateReportFile($event)">
            </app-reports-filter>
        </div>
    </div>
    <div class="row mt-3" *ngIf="reportData?.length > 0">
        <div class="col p-0">
            <div class="row adp-report-header align-items-center">
                <div class="col">{{ 'AdpReport.EmployeeName' | translate }}</div>
                <div class="col">{{ 'AdpReport.EmployeeAdpId' | translate }}</div>
                <div class="col">{{ 'AdpReport.JobCostCode' | translate }}</div>
                <div class="col">{{ 'AdpReport.SumAmount' | translate }}</div>
                <div class="col">{{ 'AdpReport.JobCostCodeDescription' | translate }}</div>
                <div class="col">{{ 'AdpReport.BusinessStructure' | translate }}</div>
            </div>
            <div class="row">
                <div class="col">
                    <app-adp-report-item *ngFor="let item of reportData" [item]="item"></app-adp-report-item>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="reportData.length === 0">
        <div class="col text-center">
            <div><span class="ic-binoculars"></span></div>
            <div>{{ 'AdpReport.NoRecords' | translate }}</div>
        </div>
    </div>
</div>
